module.exports = __webpack_public_path__ + "img/battery-bolt.62d51549.svg";